const SEQ = {
    SERVER1_URL: 'https://logweb1.devaidsoft.net',
    SERVER1_KEY: '4IHBctZiry68N7bDefWw',
};
export default SEQ;
